// core
export * from './constants.ts';
export * from './error-boundary.tsx';
export * from './lifecycle.tsx';
export * from './merge-refs.ts';
export * from './use-debounce-state.ts';
export * from './use-dependent-ref.ts';
export * from './use-instant-effect.ts';
export * from './use-isomorphic-layout-effect.ts';
export * from './use-latest-ref.ts';
export * from './use-merge-refs.ts';
export * from './use-mounted.ts';
export * from './use-stable-callback.ts';
export * from './use-storage-item.ts';
export * from './use-transition-status.ts';

// web api
export * from './dom/intersection-observer-context.ts';
export * from './dom/match-media-context.ts';
export * from './dom/resize-observer-context.ts';
export * from './dom/visual-viewport-context.ts';
export * from './dom/portal.tsx';
export * from './dom/use-exact-click.ts';
export * from './dom/use-intersection.ts';
export * from './dom/use-match-media.ts';
export * from './dom/use-outside-click.ts';
export * from './dom/use-resize.ts';
export * from './dom/use-visual-viewport.ts';

// drag-and-drop
export type {
  UseDragAndDropOptions,
  UseDragAndDropReturn,
  DragAndDropEvent,
  DragAndDropEventHandler,
  DragAndDropPlugin,
  DragAndDropPluginAPI,
  DragAndDropPluginHook,
  DragAndDropPluginHookContext,
  DragAndDropState,
} from './drag-and-drop/types.ts';
export { useDragAndDrop } from './drag-and-drop/use-drag-and-drop.ts';
export { DragAndDropBuiltinPlugins } from './drag-and-drop/builtin-plugins.ts';

// query
export { useQuery } from './query/use-query.ts';
export { useMutation } from './query/use-mutation.ts';
export { QueryMangerContext } from './query/query-manager-context.tsx';
export { MemoryQueryManager } from './query/memory-query-manager.ts';
export { MemoryQuery } from './query/memory-query.ts';
export type {
  Query,
  QueryState,
  QueryManager,
  QueryContext,
  QueryEvents,
  QueryEventMap,
  QueryDoneEvent,
  QueryFailedEvent,
  UseQueryOptions,
  UseQueryReturn,
  UseMutationOptions,
  UseMutationReturn,
} from './query/types.ts';

// router
export { RouterContext } from './router/router-context.ts';
export { type UseNavigateReturn, useNavigate } from './router/use-navigate.ts';
export { useLocation } from './router/use-location.ts';
export { useRouteParams } from './router/use-route-params.ts';

// DI
export { ContainerContext } from './di/container-context.ts';
export { type ContainerProviderProps, ContainerProvider } from './di/container-provider.tsx';
export { type DependencyHook, useDependency, createDependencyHook } from './di/use-dependency.ts';
